import { useEffect } from 'react';

// Domain redirect management component
// This handles client-side redirects when needed, but should be supplemented with server-level redirects
const DomainRedirectManager = () => {
  useEffect(() => {
    const currentHostname = window.location.hostname;
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    
    // Only redirect if we're on the secondary domain and not already on the primary domain
    if (currentHostname.includes('bornehaveguiden.dk') && 
        !currentHostname.includes('vuggestueguiden.dk')) {
      
      // Check if this is a user-initiated visit (not a redirect loop)
      const isDirectVisit = document.referrer === '' || 
                           !document.referrer.includes(currentHostname);
      
      if (isDirectVisit) {
        // Construct the primary domain URL
        const primaryUrl = `https://vuggestueguiden.dk${currentPath}`;
        
        console.log('Redirecting to primary domain:', primaryUrl);
        
        // Use replace() to avoid creating a back button loop
        window.location.replace(primaryUrl);
      }
    }
  }, []);

  return null; // This component doesn't render anything
};

export default DomainRedirectManager;
